/** Display label for profile pills: title only when value is "Primary (detail)". */
export function splitPillLabel(text: string): { primary: string; detail?: string } {
  const match = text.match(/^(.+?)\s(\([^)]*\))\s*$/);
  if (!match) {
    return { primary: text };
  }

  return {
    primary: match[1].trim(),
    detail: match[2].trim(),
  };
}

/** Title shown in the pill; parenthetical detail is omitted from the chip UI. */
export function getProfilePillDisplayLabel(text: string): string {
  return splitPillLabel(text).primary;
}
